import { Action } from '@ngrx/store';
import { IExternalUser, IExternalData, IUserAuth, ISetPassword } from '../../../commons';

export enum ProfileActionTypes {
  LoadProfileState = '[Profile] Load Profile State',
  LoadProfileStateSuccess = '[Profile] Load Profile State Success',
  VerifyEIN = '[Profile] Verify EIN',
  VerifyEINSuccess = '[Profile] Verify EIN Success',
  SubmitProfileDetail = '[Profile] Submit Profile Detail',
  SubmitProfileDetailSuccess = '[Profile] Submit Profile Detail Success',
  SetPassword = '[Profile] Set New Password',
  SetPasswordSuccess = '[Profile] Set New Password Success',
  LoadProfileStateFail = '[Profile] Load Profile State Fail',
  LoadInitState = '[Profile] Load Initiate State',
  ProfileScreenErrorReset = '[Profile] Profile Screen Error Reset'

}

export class LoadProfileState implements Action {
  readonly type = ProfileActionTypes.LoadProfileState;
}

export class LoadProfileStateSuccess implements Action {
  readonly type = ProfileActionTypes.LoadProfileStateSuccess;
  constructor(public payload: IExternalData) {}
}

export class VerifyEIN implements Action {
  readonly type = ProfileActionTypes.VerifyEIN;
  constructor(public externalData: any) {}
}

export class VerifyEINSuccess implements Action {
  readonly type = ProfileActionTypes.VerifyEINSuccess;
  constructor(public payload: string ) {}
}

export class SubmitProfileDetail implements Action {
  readonly type = ProfileActionTypes.SubmitProfileDetail;
  constructor(public profile: any) {}
}

export class SubmitProfileDetailSuccess implements Action {
  readonly type = ProfileActionTypes.SubmitProfileDetailSuccess;
  constructor(public payload: string ) {}
}

export class SetPassword implements Action {
  readonly type = ProfileActionTypes.SetPassword;
  constructor(public loginInfo: ISetPassword) {}
}

export class SetPasswordSuccess implements Action {
  readonly type = ProfileActionTypes.SetPasswordSuccess;
  constructor(public payload: string ) {}
}

export class LoadProfileStateFail implements Action {
  readonly type = ProfileActionTypes.LoadProfileStateFail;
  constructor(public payload: any ) {}
}

export class ProfileScreenErrorReset implements Action {
  readonly type = ProfileActionTypes.ProfileScreenErrorReset;
}

export class LoadInitState implements Action {
  readonly type = ProfileActionTypes.LoadInitState;
}

export type ProfileActions = 
LoadProfileState
  | LoadProfileStateSuccess
  | VerifyEIN
  | VerifyEINSuccess
  | SubmitProfileDetail
  | SubmitProfileDetailSuccess
  | SetPassword
  | SetPasswordSuccess
  | LoadProfileStateFail
  | LoadInitState
  | ProfileScreenErrorReset;